import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ error, info });
    if (typeof console !== "undefined") {
      console.error("[Safe Zap] Erro capturado pelo ErrorBoundary:", error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.error) return this.props.children;

    const { error, info } = this.state;
    const stack = (info && info.componentStack) || "";

    return (
      <div
        style={{
          padding: "40px 32px",
          minHeight: "100vh",
          background: "#0f172a",
          color: "#f1f5f9",
          fontFamily: "system-ui, -apple-system, Segoe UI, sans-serif",
          overflow: "auto",
        }}
      >
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <h1 style={{ fontSize: 22, marginBottom: 8 }}>Algo quebrou ao renderizar esta tela</h1>
          <p style={{ opacity: 0.8, marginBottom: 24 }}>
            Esta mensagem aparece em vez de uma tela branca. Tire um screenshot e envie para o suporte.
          </p>

          <button
            type="button"
            onClick={this.handleReload}
            style={{
              background: "#22c55e",
              color: "#0b1220",
              border: 0,
              padding: "10px 16px",
              borderRadius: 8,
              fontWeight: 600,
              cursor: "pointer",
              marginBottom: 24,
            }}
          >
            Recarregar a página
          </button>

          <div
            style={{
              background: "#1e293b",
              border: "1px solid #334155",
              borderRadius: 8,
              padding: 16,
              marginBottom: 16,
            }}
          >
            <strong style={{ color: "#fca5a5" }}>{error?.name || "Error"}</strong>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                margin: "8px 0 0",
                fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                fontSize: 13,
              }}
            >
              {String(error?.message || error)}
            </pre>
          </div>

          {error?.stack && (
            <details style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 8, padding: 16, marginBottom: 16 }}>
              <summary style={{ cursor: "pointer", fontWeight: 600 }}>Stack trace</summary>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  margin: "8px 0 0",
                  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                  fontSize: 12,
                  opacity: 0.85,
                }}
              >
                {error.stack}
              </pre>
            </details>
          )}

          {stack && (
            <details style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 8, padding: 16 }}>
              <summary style={{ cursor: "pointer", fontWeight: 600 }}>Componentes envolvidos</summary>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                  margin: "8px 0 0",
                  fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
                  fontSize: 12,
                  opacity: 0.85,
                }}
              >
                {stack}
              </pre>
            </details>
          )}
        </div>
      </div>
    );
  }
}
